<template>
    <img
        src="/images/case-of-the-month.svg"
        class="case-of-the-month-image"
    >
</template>

<style lang="less">
.case-of-the-month-image {
    display: block;
    position: absolute;
    width: 150px;
    padding: var(--spacing-xs);
    z-index: 10;

    @media @q-md-min {
        width: 200px;
        padding: var(--spacing-md);
    }
}
</style>
